import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  me: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenter-milestones/me`,
  },
  claimOffer: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presenter-milestones/me/offer/claim`,
  },
  setShowcase: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/presenter-milestones/me/showcase`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const me = () => resource.me()

const claimOffer = () => resource.claimOffer({}, {})

const setShowcase = (optIn) => resource.setShowcase({}, { optIn })

export default {
  initResource,
  me,
  claimOffer,
  setShowcase,
}
